import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter, startWith } from 'rxjs/operators';

/*
    This class has a "previousContentFormUrl" property which will either be to a Site's home-page or its structure
    FormInstanceComponents are intrested in this value and use it to know whether their close button should go to
    home-page or structure
*/

@Injectable()
export class PreviousRouteService {
    private previousContentFormUrl: string | undefined;

    constructor(private router: Router) {
        this.router.events.pipe(                                                       
            filter((event): event is NavigationEnd => event instanceof NavigationEnd),
            // startWith() ensures we get an initial value
            startWith(this.router)).subscribe((event: NavigationEnd) => {
            if (this.isContentFormRoute()) {
                this.previousContentFormUrl = this.router.url;
            }
        });
    }

    public getPreviousContentFormUrl(): string | undefined {
        return this.previousContentFormUrl;
    }

    // Helpers
    private isContentFormRoute() {
        return this.router.url.indexOf('structure') > -1 ||
            this.router.url.indexOf('home-page') > -1;
    }
}
